import A from './types';
import filter from 'lodash/filter';

const initialState = {};
const reducer = (state, action) => {
  switch (action.type) {
    case A.ADD_MY_COMPANY: {
      const key = Object.keys(action.payload);
      const value = Object.values(action.payload);
      return Object.assign({}, state, {
        [key[0]]: value[0],
      });
    }
    case A.EMPTY_MY_COMPANY: {
      return {save: null, hide: null};
    }
    case A.REMOVE_MY_COMPANY: {
      const type = action.payload.brokerType;
      const brokerArr = state[type];
      const newArr = filter(brokerArr, item => item.broker_id !== action.payload.id);
      return Object.assign({}, state, {[type]: newArr});
      //   return state
    }
  }
  return null;
};
export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/myCompany/reducer.js